import { SESSIONS, type MarketEvent, type Session } from '@/mocks/marketCalendar';
import { dateLabel } from '../calculations';

export default function TodayGlance({
  todayEvents,
  currentSession,
}: {
  todayEvents: MarketEvent[];
  currentSession: Session;
}) {
  const total = todayEvents.length;
  const high = todayEvents.filter((e) => e.impact === 'high').length;
  const currencies = Array.from(new Set(todayEvents.map((e) => e.currency)));
  const markets =
    currencies.includes('XAU') && currencies.includes('USD')
      ? 'Forex / Gold / Indices'
      : 'Forex / Gold / Indices';

  const items = [
    { label: 'Sự kiện hôm nay', value: String(total), icon: 'ri-calendar-event-line', tone: 'text-slate-900' },
    { label: 'Sự kiện tác động cao', value: String(high), icon: 'ri-flashlight-line', tone: 'text-rose-600' },
    { label: 'Thị trường đang hoạt động', value: markets, icon: 'ri-global-line', tone: 'text-slate-900' },
  ];

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h2 className="font-display text-xl font-bold tracking-tight text-slate-900 md:text-2xl">
            Hôm nay trên thị trường
          </h2>
          <p className="mt-1.5 flex items-center gap-2 text-sm text-slate-500">
            <i className="ri-calendar-2-line text-slate-400" />
            {dateLabel(0)}
          </p>
        </div>

        {/* Current session status */}
        <div className="flex items-center gap-3 rounded-2xl border border-slate-200/80 bg-slate-50/60 px-4 py-3">
          <span
            className="flex h-10 w-10 items-center justify-center rounded-xl"
            style={{ backgroundColor: `${currentSession.color}1a`, color: currentSession.color }}
          >
            <i className={`${currentSession.icon} text-lg`} />
          </span>
          <div>
            <p className="text-[11px] font-medium uppercase tracking-wide text-slate-500">Phiên hiện tại</p>
            <p className="text-sm font-bold text-slate-800">{currentSession.name}</p>
          </div>
          <span className="ml-2 inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-600">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
            </span>
            OPEN
          </span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3 rounded-2xl border border-slate-200/80 bg-slate-50/50 p-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-slate-500 ring-1 ring-slate-200">
              <i className={`${it.icon} text-lg`} />
            </span>
            <div className="min-w-0">
              <p className="text-[11px] font-medium uppercase tracking-wide text-slate-500">{it.label}</p>
              <p className={`truncate font-mono text-lg font-bold tabular-nums ${it.tone}`}>{it.value}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-4 flex items-center gap-1.5 text-[11px] text-slate-400">
        <i className="ri-information-line" />
        Dữ liệu mẫu — thời gian sự kiện chỉ mang tính minh hoạ, múi giờ có thể tuỳ chỉnh ở phía trên.
      </p>
    </section>
  );
}